import { useState } from "react";
import AnimatedRow from "./AnimatedRow";

const SpecialistsSection = ({ row1, row2 }) => {
  return (
    <section className="bg-[#EEF7FF] text-[#212129] py-8 lg:py-16">
      {/* Heading */}
      <div className="w-[90%] sm:w-3/4 md:w-3/5 max-w-[620px] mx-auto text-center flex flex-col items-center mb-6 md:mb-12">
        <h2 className="text-[32px] md:text-[48px] lg:text-[64px] leading-tight font-regular mb-[32px]">
          Our Specialist
        </h2>

        <span className="block w-[84px] border-b-2 border-[#07862B] mb-[32px]"></span>

        <p className="text-sm md:text-base lg:text-lg leading-normal font-light m-0 opacity-80">
          Skilled professionals driving impactful results with experience,
          precision, and commitment.
        </p>
      </div>

      {/* Rows */}
      <div className="max-w-7xl mx-auto">
        <AnimatedRow items={row1} />
        <AnimatedRow items={row2} reverse />
      </div>
    </section>
  );
};

export default SpecialistsSection;
